(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('Contrat', Contrat);

    Contrat.$inject = ['$resource', 'DateUtils'];

    function Contrat ($resource, DateUtils) {
        var resourceUrl =  'api/contrats/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            
            
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateCloture = DateUtils.convertLocalDateFromServer(data.dateCloture);
                    data.dateActivation = DateUtils.convertLocalDateFromServer(data.dateActivation);
                    data.lastStatusChangeDate = DateUtils.convertDateTimeFromServer(data.lastStatusChangeDate);
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.dateCloture = DateUtils.convertLocalDateToServer(data.dateCloture);
                	clonedData.dateActivation = DateUtils.convertLocalDateToServer(data.dateActivation);
                    return angular.toJson(clonedData);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.dateCloture = DateUtils.convertLocalDateToServer(data.dateCloture);
                	clonedData.dateActivation = DateUtils.convertLocalDateToServer(data.dateActivation);
                    return angular.toJson(clonedData);
                }
            },
//            'delete': {
//                method: 'DELETE',
//                transformRequest: function (data) {
//                    return angular.toJson(data);
//                }
//            },
            'cloturer': {
                method: 'POST',
              	url :'api/contrats/cloturer',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'createCorrectionWaterConsumption': {
                method: 'POST',
              	url :'api/contrats/create-correction-water-consumption',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                 	clonedData.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                 	clonedData.dateDebut = DateUtils.convertDateTimeFromServer(data.dateDebut);
                 	clonedData.dateFin = DateUtils.convertDateTimeFromServer(data.dateFin);
                    return angular.toJson(clonedData);
                }
            },
            'activer': {
                method: 'POST',
              	url :'api/contrats/activer',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.dateActivation = DateUtils.convertLocalDateToServer(data.dateActivation);
                    return angular.toJson(clonedData);
                }
            },
            'changeStatus': {
                method: 'POST',
                url: 'api/contrats/change-status',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'addNote': {
                method: 'POST',
                url: 'api/contrats/add-note',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'getHistory': {
                method: 'GET',
                isArray: true,
                url: 'api/contrats/:id/history',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    angular.forEach(data, function(item) {
                        item.eventDate = DateUtils.convertDateTimeFromServer(item.eventDate);
                    });
                    return data;
                }
            },
            'downloadcsv': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/contrats/downloadcsv',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            },
            'downloadServicecsv': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/contrats/downloadDetailServicecsv',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            },
            

            'downloadDetailServiceNotClosedcsv': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/contrats/downloadDetailServiceNotClosedcsv',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            },

            'downloadImpayeMobileMoney': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/contrats/downloadimpayemobilemoney',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            },
            'downloadContractJson': {
                method: 'GET',
                headers: {
                    accept: 'application/json'
                },
                responseType: 'arraybuffer',
                url :'api/contrats/:id/downloadjson',
                transformResponse: function (data,headers) {
                    var filename = headers('FileName');
                    var contentType = headers('ContentType');
                    var jsonFile;
                    if (data) {
                        jsonFile = new Blob([data], {
                            type: contentType || 'application/json'
                        });
                    }
                    return {
                        response: jsonFile,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            },
            'chatAssistant': {
                method: 'POST',
                url: 'api/contrats/:id/assistant/chat',
                transformRequest: function(data) {
                    return angular.toJson(data);
                }
            },
            'getAssistantUsage': {
                method: 'GET',
                url: 'api/contrats/:id/assistant/usage'
            },
            'recoverAssistantResponse': {
                method: 'GET',
                url: 'api/contrats/:id/assistant/recover'
            },
            'submitAssistantFeedback': {
                method: 'POST',
                url: 'api/contrats/:id/assistant/feedback',
                transformRequest: function(data) {
                    return angular.toJson(data);
                }
            },
            'executeAssistantActions': {
                method: 'POST',
                url: 'api/contrats/:id/assistant/execute-actions',
                transformRequest: function(data) {
                    return angular.toJson(data);
                }
            },
            'addOnlinePayment': {
                method: 'POST',
              	url :'api/contrats/add-online-payment',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                 	clonedData.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                 	clonedData.deletedDate = DateUtils.convertLocalDateToServer(data.deletedDate);
                    return angular.toJson(clonedData);
                }
            },
            'getOnlinePayment': {
                method: 'GET',
              	url :'api/contrats/online-payment/:idOnlinePayment',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
//                    data.dateCloture = DateUtils.convertLocalDateFromServer(data.dateCloture);
//                    data.dateActivation = DateUtils.convertLocalDateFromServer(data.dateActivation);
                    return data;
                }
            },
            'updateOnlinePayment': {
                method: 'PUT',
                url: 'api/contrats/online-payment/:idOnlinePayment',
                params: {
                    idOnlinePayment: '@id'
                },
                transformRequest: function(data) {
                    return angular.toJson(data);
                }
            },
	        'deleteOnlinePayment': {
		          method: 'DELETE',
	              url :'api/contrats/online-payment/:idOnlinePayment',
		          transformRequest: function (data) {
		              return angular.toJson(data);
		          }
		      },
            'getListOnlinePayment': {
                method: 'GET',
              	url :'api/contrats/:idContrat/online-payment',
             	isArray: true
            },
            'getOnlinePaymentHistory': {
                method: 'GET',
                url: 'api/contrats/online-payment/:idOnlinePayment/history',
                isArray: true,
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    angular.forEach(data, function(item) {
                        item.revisionDate = DateUtils.convertDateTimeFromServer(item.revisionDate);
                        item.deletedDate = DateUtils.convertDateTimeFromServer(item.deletedDate);
                        item.createdDate = DateUtils.convertDateTimeFromServer(item.createdDate);
                        item.lastModifiedDate = DateUtils.convertDateTimeFromServer(item.lastModifiedDate);
                    });
                    return data;
                }
            },
            'getCommunicationSubscriptions': {
                method: 'GET',
                url: 'api/communication-subscriptions/by-contrat/:idContrat',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    angular.forEach(data, function(subscription) {
                        subscription.date = DateUtils.convertDateTimeFromServer(subscription.date);
                    });
                    return data;
                }
            },
            'addCommunicationSubscription': {
                method: 'POST',
                url: 'api/communication-subscriptions',
                transformRequest: function (data) {
                    var clonedData = Object.assign({}, data);
                    clonedData.date = DateUtils.convertDateTimeFromServer(data.date);
                    return angular.toJson(clonedData);
                }
            },
            'updateCommunicationSubscription': {
                method: 'PUT',
                url: 'api/communication-subscriptions',
                transformRequest: function (data) {
                    var clonedData = Object.assign({}, data);
                    clonedData.date = DateUtils.convertDateTimeFromServer(data.date);
                    return angular.toJson(clonedData);
                }
            }
            
        });
    }
})();
